import {trans} from 'utils/helpers/translation'

export default {
    weekNames: [
        trans('_calendar.sun'),
        trans('_calendar.mon'),
        trans('_calendar.tue'),
        trans('_calendar.wed'),
        trans('_calendar.thu'),
        trans('_calendar.fri'),
        trans('_calendar.sat')
    ],
    monthNames: [
        trans('_calendar.january'),
        trans('_calendar.february'),
        trans('_calendar.march'),
        trans('_calendar.april'),
        trans('_calendar.may'),
        trans('_calendar.june'),
        trans('_calendar.july'),
        trans('_calendar.august'),
        trans('_calendar.september'),
        trans('_calendar.october'),
        trans('_calendar.november'),
        trans('_calendar.december')
    ],
    titleFormat: 'MMMM yyyy'
}



// WEBPACK FOOTER //
// ./src/components/helpers/full_calendar/langSets.js